import { useQuery } from '@urql/vue';
import { type Environment, ENVIRONMENTS } from '@/graphql/environments';
import { computed } from 'vue';

const ENVIRONMENT_SORT_ORDER: Record<string, number> = {
  prd: 0,
  chn: 1,
  dev: 2
};

function sortEnvironments(envs: Environment[]): Environment[] {
  return [...envs].sort((a, b) => {
    const oa = ENVIRONMENT_SORT_ORDER[a.id];
    const ob = ENVIRONMENT_SORT_ORDER[b.id];
    if (oa !== undefined && ob !== undefined) return oa - ob;
    if (oa !== undefined) return -1;
    if (ob !== undefined) return 1;
    return a.id.localeCompare(b.id);
  });
}

export function useEnvironments() {
  const { fetching, data, error } = useQuery<{ environments: Environment[] }>({
    query: ENVIRONMENTS,
    requestPolicy: 'cache-first'
  });

  const environments = computed(() => sortEnvironments(data.value?.environments || []));
  const filters = computed(() => {
    const f = [] as Environment[];
    f.push({ id: '', description: 'Unassigned' }, ...environments.value);
    return f;
  });

  return {
    fetching,
    error,
    environments,
    filters
  };
}
